import { render, staticRenderFns } from "./MapBookmarks.vue?vue&type=template&id=2ea59d16"
import script from "./MapBookmarks.vue?vue&type=script&lang=js"
export * from "./MapBookmarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports